import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
    { path: '', pathMatch: 'full', component: HomeComponent },
    { path: 'fetch-data', component: FetchDataComponent },
    { path: 'signin-microsoft', component: LoginComponent },
    /*{
        path: '404',
        component: PageNotFoundComponent,
    },
    {
        path: '**',
        redirectTo: '/404',
    },*/
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
})
export class AppRoutingModule {}
